import React, { useState } from "react";
import Swal from "sweetalert2";
import { Form, Typography } from "antd";
import { LoginWrapper } from "./style";
import loginImage from "../../assets/images/login-1.png";
import loginLogo from '../../assets/images/newlog.svg';
import { customBaseUrl, httpPost } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import PinModal from "../../components/Modal/Pin/PinModal";
import GlassCard from "../../components/premium/GlassCard";
import PremiumButton from "../../components/premium/PremiumButton";
import PremiumInput from "../../components/premium/PremiumInput";

const { Title, Text } = Typography;

export default function LoanAdminLogin() {
  const [loading, setLoading] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");

  const handleSuccessfulLogin = (res) => {
    const { token, admin } = res;
    localStorage.setItem("loanAdminToken", token);
    localStorage.setItem("roles", JSON.stringify(admin?.roles));
    localStorage.setItem("loanAdminUser", JSON.stringify(admin));
    window.location.href = "/loan-admin-dashboard";
  };

  const handleOtpSubmit = async () => {
    if (otp.length !== 6) {
      return Swal.fire("Error", "Please enter a valid 6-digit OTP.", "error");
    }
    showLoader();
    const payload = { email, otp };

    try {
      const res = await httpPost(`${customBaseUrl.loanUrl}/api/v1/admin/login/verify-otp`, payload);
      hideLoader();
      if (res.status) {
        setShowOtpModal(false);
        handleSuccessfulLogin(res);
      } else {
        Swal.fire("Login Failed", res.message, "error");
      }
    } catch (error) {
      hideLoader();
      Swal.fire("Error", "Something went wrong.", "error");
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    showLoader();
    const payload = { email: values.username, password: values.password };

    try {
      const res = await httpPost(`${customBaseUrl.loanUrl}/api/v1/admin/login`, payload);
      hideLoader();
      setLoading(false);

      if (res.status) {
        if (res.message === "OTP sent to your email for 2FA verification.") {
          setShowOtpModal(true);
          setEmail(values.username);
        } else {
          handleSuccessfulLogin(res);
        }
      } else {
        Swal.fire("Login Failed", res.message, "error");
      }
    } catch (error) {
      hideLoader();
      setLoading(false);
      Swal.fire("Error", "Unable to login.", "error");
    }
  };

  return (
    <LoginWrapper>
      <div className="auth-container">
        <div className="auth-info">
          <div className="logo-container">
            <img src={loginLogo} alt="WayaBank Logo" />
          </div>
          <h1>Loan Admin <br />Portal.</h1>
          <p>The premium portal for managing loan requests and credit facilities.</p>
          <img src={loginImage} alt="Loan Admin Illustration" style={{ marginTop: '40px', width: '80%', maxWidth: '400px' }} />
        </div>

        <div className="auth-form-section">
          <GlassCard padding="48px" radius="24px">
            <Title level={2} style={{ marginBottom: '8px', fontWeight: 600 }}>Loan Admin Sign in</Title>
            <Text type="secondary" style={{ display: 'block', marginBottom: '32px' }}>
              Access the loan management system
            </Text>

            <Form layout="vertical" onFinish={onFinish} autoComplete="off">
              <Form.Item label="Admin Email" name="username" rules={[{ required: true, message: 'Required' }]}>
                <PremiumInput placeholder="loanadmin@wayabank.com" />
              </Form.Item>

              <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Required' }]}>
                <PremiumInput.Password placeholder="••••••••" />
              </Form.Item>

              <Form.Item style={{ marginTop: '32px' }}>
                <PremiumButton type="primary" htmlType="submit" loading={loading} block style={{ height: '48px' }}>
                  Sign in
                </PremiumButton>
              </Form.Item>
            </Form>
          </GlassCard>
        </div>
      </div>

      {showOtpModal && (
        <PinModal
          showModal={showOtpModal}
          hideModal={() => setShowOtpModal(false)}
          otp={otp}
          setOtp={setOtp}
          numInputs={6}
          title='2FA Verification'
          description='Please input the OTP sent to your Email'
          pinMode={true}
          handleSubmit={handleOtpSubmit}
          buttonLabel="Verify"
        />
      )}
    </LoginWrapper>
  );
}
